/**
 * This enum is used in the GetHospitalSchedule SPROC to merge similar tables where the only main difference is between a template ID and a vet id, so we give them an EntityID (vet or template id) and an entity type, 0 for vet and 100 for template.
 */
export enum EntityScheduleType {
    Veterinarian = 1,
    Template = 100,
    Unassigned = 200,
    Technician = 400
}
